<template>
  <Modal id="error-handler-modal" :showModal="isStoreError" @close="globalErrorModal">
    <template #header>
      <h4 class="alert-heading text-start">Une erreur est survenue</h4>
    </template>
    <template #body>
      <p>
        <span style="display:block;">Code de l'erreur:</span>
        <span class="ms-3">{{ getClirError.status }}</span>
      </p>

      <p>
        <span style="display:block;">Message:</span>
        <span class="ms-3">{{ getClirError.statusText }}</span>
      </p>

      <div v-if="functionalErrors">
        <div v-for="error in functionalErrors" :key="error.key">
          <DataCollapser
            :datas="error"
            collapseKey="code"
            collapseKeyClass="fw-bolder"
            subKeysClass="fw-lighter"
            subDatasClass="fst-italic"
            isInitiallyCollapsed
            showKeys
          ></DataCollapser>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="w-100 text-center d-flex justify-content-around">
        <button class="btn btn-lg btn-primary px-5" @click="globalErrorModal" type="button">Ok</button>
        <button
          v-if="isLoginError"
          class="btn btn-lg btn-primary px-5"
          @click="toLogin"
          type="button"
        >M'identifier</button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@clir/Modal/Modal";
import getKey from "@/clir/utils/getKey";
import DataCollapser from "@clir/DataCollapser/DataCollapser";

/**
 * Composant d'affichage des messages d'erreur dans une Modal
 *
 * @author <span><span class="fw-bold">Nicolas Huber</span><a class="ms-2" href="mailto:dmod-huber.consultant@dgfip.finances.gouv.fr">dmod-huber.consultant@dgfip.finances.gouv.fr</a></span>
 * @since <span class="fw-bold">Version 1.0</span>
 * @displayName ModalError
 */
export default {
  name: "ModalError",
  computed: {
    isStoreError() {
      return this.isError;
    },
    isLoginError() {
      return getKey(this.getClirError, "options.route.name", false) === "Login";
    },
    functionalErrors() {
      return getKey(this.getClirError, "options.errorList", null);
    }
  },

  components: {
    Modal,
    DataCollapser
  },
  methods: {
    toLogin() {
      const route = getKey(this.getClirError, "options.route", "");
      this.resetError();
      this.$router.push(route);
    },
    globalErrorModal() {
      this.resetError();
    }
  }
};
</script>

<style>
</style>

<docs>
```[import](./__example__/ModalErrorExample.vue)
```
</docs>